// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddSkillsLevelModal_fieldSet__8mK9z"};